import React from "react";
import { Form } from "react-bootstrap";

interface FormFieldProps {
  label: string;
  helpText?: string;
  name: string;
  type?: string;
  placeholder?: string;
  value?: string;
  error?: boolean;
  as?: React.ElementType;
  children?: React.ReactNode;
  disabled?: boolean;
  validated?: boolean;
  onChange?: (event: React.ChangeEvent<any>) => void;
  className?: string;
  minDate?: string; // Add min date for date input
  maxDate?: string; // Add max date for date input
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  helpText,
  name,
  type = "text",
  placeholder,
  value,
  error = false,
  as = "input",
  children = null,
  disabled = false,
  validated = false,
  onChange,
  className,
  minDate,
  maxDate,
}) => (
  <Form.Group className={className}>
    <Form.Label data-variant="label-2-bold">{label}</Form.Label>
    {helpText && <Form.Text className="text-muted">{helpText}</Form.Text>}
    {children || (
      <Form.Control
        size="lg"
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        isInvalid={error && validated}
        isValid={!error && validated}
        as={as}
        min={type === "date" ? minDate : undefined}
        max={type === "date" ? maxDate : undefined}
      />
    )}
  </Form.Group>
);

export default FormField;
